<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-select v-model="form.enable" clearable placeholder="是否启用">
                        <el-option label="启用" value="true"></el-option>
                        <el-option label="不启用" value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="编程语言">
                    <mine-select v-model="form.type" url="/common/lessonType"
                                 valueField="optionValue" labelField="optionText"  placeholder="编程语言">
                    </mine-select>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="edit({})">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                v-loading="loading"
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    prop="sn"
                    min-width="120"
                    label="编号">
                </el-table-column>
                <el-table-column
                    prop="title"
                    min-width="120"
                    label="任务名称">
                </el-table-column>
                <el-table-column
                    prop="typeName"
                    min-width="120"
                    label="编程语言">
                </el-table-column>
                <el-table-column
                    prop="levelName"
                    min-width="120"
                    label="等级">
                </el-table-column>
                <el-table-column
                    label="讲解视频"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <template v-if="scope.row.videos.length > 0">
                            <el-button  type="primary" @click="setShowResources(scope.row.videos)"  size="small">查看</el-button>
                        </template>
                        <template v-else>
                            <span class="text_info">未设置</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    label="随堂资料"
                    min-width="120"
                    class="aaa"
                >
                    <template slot-scope="scope">
                        <template v-if="scope.row.attachments.length > 0">
                            <el-button type="primary" @click="setShowResources(scope.row.attachments)" size="small">查看</el-button>
                        </template>
                        <template v-else>
                            <span class="text_info">未设置</span>
                        </template>

                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="代码">
                    <template slot-scope="scope">
                        <template v-if="scope.row.codes.length > 0">
                            <el-button type="primary" @click="viewCode(scope.row.type,scope.row.codes[0].id)" size="small">查看</el-button>
                        </template>
                        <template v-else>
                            <span class="text_info">未设置</span>
                        </template>

                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="卡片">
                    <template slot-scope="scope">
                        <template v-if="scope.row.tutorials.length > 0">
                            <el-button type="primary" @click="setShowResources(scope.row.tutorials)" size="small">查看</el-button>
                        </template>
                        <template v-else>
                            <span class="text_info">未设置</span>
                        </template>

                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="成品代码">
                    <template slot-scope="scope">
                        <template v-if="scope.row.linkCodes.length > 0">
                            <el-button type="primary" @click="viewCode(scope.row.type,scope.row.linkCodes[0].id)" size="small">查看</el-button>
                        </template>
                        <template v-else>
                            <span class="text_info">未设置</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="240"
                    label="标签">
                    <template slot-scope="scope">
                        <tag-group :tags="scope.row.tagArray" size="medium"></tag-group>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="是否开启">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enable"
                                   @change="modifyEnable(scope.row)"
                                   inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                    fixed="right"
                >
                    <template slot-scope="scope">

                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false"><i class="iconfont icon-bianji"></i>编辑
                        </el-link>
                        <br>
                        <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认删除该任务吗？"
                        >
                        <el-link type="danger" slot="reference"  :underline="false"><i class="iconfont icon-shanchu"></i>删除
                        </el-link>
                        </el-popconfirm>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

        <VideoDrawer v-if="showVideo" @close="showVideo=false" :url="currentVideo"></VideoDrawer>

        <TutorialDrawer :showBox="showResources" @play="play"
                        @close="showResources=false" label="任务资源列表" :resources="currentResources"></TutorialDrawer>

        <TaskEdit v-if="showEdit" @close="showEdit=false" :item="editItem" @submit="loadData"></TaskEdit>
    </div>
</template>

<style scoped>

</style>
<style>

</style>

<script>
    import VideoDrawer from '@/components/VideoDrawer';
    import TutorialDrawer from '@/components/ResourceDrawer';
    import TaskEdit from "./TaskEdit";


    export default {
        components: {
            VideoDrawer,
            TutorialDrawer,
            TaskEdit
        },
        props: [],
        data() {
            return {
                showVideo: false,
                currentVideo: "",

                showResources: false,
                currentResources: [],

                showEdit: false,

                form: {
                    keywords: "",
                    enable: "",
                    type: null,
                },
                editItem: {},
                loading: false,
                tableData: [],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                lessonTypes: [],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            }
        },

        methods: {
            edit(item) {
                this.editItem = {...item};
                this.showEdit = true;

            },
            play(url) {
                this.currentVideo = url;
                this.showVideo = true;
            },
            del(item) {
                this.$ajaxGet("/lessonTask/del/"+item.id, (data) => {
                    this.loadData();
                })
            },

            modifyEnable(item) {
                this.$ajaxGet("/lessonTask/toggleEnable/" + item.id + "-" + item.enable);
            },

            editCode(item) {

            },
            setShowResources(resources) {
                this.currentResources = resources;
                this.showResources = true;
            },
            loadData() {
                this.loading = true;
                this.$ajaxPost("/lessonTask/list", {
                    form: this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    let items = data.result;
                    items.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.attachments = item.resources.filter(r => r.category == 2);
                        item.codes = item.resources.filter(r => r.category == 3);
                        item.tutorials = item.resources.filter(r => r.category == 4);
                        item.linkCodes = item.linkResources.filter(r => r.category == 4);
                    })
                    this.tableData = items;
                    this.showEdit = false;
                    this.loading = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonType", (data) => {
                    this.lessonTypes = data.result;
                })
            },
            viewCode(lessonType, id) {
                this.$goEditCode(lessonType, `mode=caseview&id=${id}`);
            }
        },

        created() {
            this.loadLessonTypes();
            this.loadData();
        }

    }
</script>
